"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validationReportCreatedSchema = void 0;
exports.validationReportCreatedSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        /* eslint-disable-next-line no-template-curly-in-string */
        errorMessage: '- should not have additional property ${0#}',
    },
    required: ['blobUrl', 'metadata'],
    properties: {
        blobUrl: {
            type: 'string',
            errorMessage: 'Should be a string',
        },
        metadata: {
            type: 'object',
            additionalProperties: {
                not: true,
                /* eslint-disable-next-line no-template-curly-in-string */
                errorMessage: '- should not have additional property ${0#}',
            },
            required: ['validationReportUpdatedTimestamp', 'reportingPeriodID'],
            properties: {
                validationReportUpdatedTimestamp: {
                    type: 'string',
                    pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
                    errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
                },
                reportingPeriodID: {
                    type: 'string',
                    format: 'uuid',
                    errorMessage: 'should follow UUID format 00000000-0000-0000-0000-000000000000',
                },
            },
        },
        documentName: {
            type: 'string',
            errorMessage: 'Should be a string',
        },
    },
};
